import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

export type SelectedGroup = { id: number }

type GroupsFormState = {
  selected: SelectedGroup[]
}

type GroupsFormActions = {
  setSelected: (groups: SelectedGroup[]) => void
  toggleGroup: (group: SelectedGroup) => void
  reset: () => void
}

export const useGroupsFormStore = create<GroupsFormState & GroupsFormActions>()(
  devtools(
    zustandPlugin(
      (set) => ({
        selected: [],
        setSelected: (selected) => set({ selected }, false, 'setSelected'),
        toggleGroup: (group) =>
          set(
            (s) => ({
              selected: s.selected.some((g) => g.id === group.id)
                ? s.selected.filter((g) => g.id !== group.id)
                : [...s.selected, group],
            }),
            false,
            'toggleGroup',
          ),
        reset: () => set({ selected: [] }, false, 'reset'),
      }),
      'groups-form',
    ),
    { name: 'EasyTacho', store: 'groups-form' },
  ),
)

export const selectIsGroupSelected = (id: number) => (s: GroupsFormState) =>
  s.selected.some((g) => g.id === id)
